import type { TStyleWrapper } from './type';

// Здесь делаем исключение, чтобы не добавлять правило из папки styles
// eslint-disable-next-line import/no-unassigned-import, import/no-internal-modules
import '../../styles/themeStyles/default.scssGlobal';

export const DefaultStylesWrapper = ({ children }: TStyleWrapper) => children;
